export default {
  routes: {
    home: "/",
    about_us: "/a-propos-de-nesto",
    get_quote: "/comparer-les-taux",
    rates: "/taux",
    calculator: "/calculatrice",
    reverse: "/inverse",
    frequently_asked_questions: "/faq",
    terms: "/condition-utilisation",
    privacy: "/Politique-de-confidentialite",
    howitworks: "/#notre-approche",
    howitworksid: "notre-approche",
    faq: "faq"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/translations/fr/routes.js